import React from 'react';
import { formatMoney } from '../utils/money';

/**
 * Coupon stub value as two lines: a big figure ("20%", "$5", "FREE") + a small word ("OFF", "1 month").
 * The figure never wraps (nowrap); its size steps down with its length and with the stub width (container units),
 * so long words in ru / es / ms or CJK never break mid-word. Same split as api MailLayout::couponValueParts.
 */
export const ticketValueParts = (c, t) => {
    if (c.type === 'trial') return { big: t('FREE'), small: t(c.trial_cycle === 'quarterly' ? '1 quarter' : '1 month') };
    if (c.type === 'percent') return { big: `${Number(c.value)}%`, small: t('OFF') };
    return { big: formatMoney(c.value, c.currency), small: t('DISCOUNT') };
};

/** Font size for the big figure: by length, capped by the stub width (cqi needs .cpt-stub { container-type: inline-size }). */
export const bigSize = (text) => {
    const n = [...String(text)].length;
    const px = n <= 4 ? 34 : n <= 6 ? 28 : n <= 8 ? 22 : n <= 10 ? 18 : 15;
    return `min(${px}px, ${Math.round((px / 1.25) * 10) / 10}cqi)`; // full size from a ~125px stub, smaller below
};

const TicketValue = ({ c, t }) => {
    const { big, small } = ticketValueParts(c, t);
    return (
        <span className="cpt-value">
            <span className="cpt-value-big" style={{ fontSize: bigSize(big) }}>{big}</span>
            <span className="cpt-value-small">{small}</span>
        </span>
    );
};

export default TicketValue;

/** One-line offer ("20% off" / "$5 off" / "1 month free"), always via the console's t() — never server text. */
export const offerText = (c, t) => {
    if (!c) return '';
    if (c.type === 'trial') return t(c.trial_cycle === 'quarterly' ? '1 quarter free' : '1 month free');
    if (c.type === 'percent') return t('{{value}}% off', { value: Number(c.value) });
    return t('{{value}} off', { value: formatMoney(c.value, c.currency) });
};
